export { BLOG_SECTION_ID } from 'communities-universal/dist/src/constants/appsConfig';
export const BLOG_FEED_PATH = 'blog-feed.xml';
export const ROOT_ELEMENT_SELECTOR = '#root';
export const SVG_ICON_SELECTOR = 'svg';
export const DEFAULT_COLOR = '#FF6602';



// WEBPACK FOOTER //
// ./rss-feed-widget/constants/app.js